import { BRAND } from "../lib/brand"
import { Link } from "../lib/router"
import { useLanguage } from "../lib/LanguageContext"

export default function Footer() {
  const { t } = useLanguage()

  const NAV_LINKS = [
    { href: "#how-it-works", label: t("nav_how_it_works") },
    { href: "#features",     label: t("nav_features") },
    { href: "#clubs",        label: t("nav_clubs") },
    { href: "#faq",          label: t("nav_faq") },
  ]

  return (
    <footer className="border-t border-white/[0.16] bg-ink-800 pb-12 pt-24">
      <div className="container mx-auto mb-24 flex max-w-content flex-wrap justify-between gap-16 px-6 sm:px-16">
        <div className="max-w-[320px]">
          <div className="mb-6 font-display text-2xl font-semibold text-paper-0">{BRAND.name}</div>
          <p className="mb-6 font-semibold leading-[1.3] text-paper-0">{t("brand_description")}</p>
          <p className="text-sm text-mist-300">{t("brand_powered_by")}</p>
        </div>
        <div className="flex flex-wrap gap-24">
          <div>
            <div className="mb-4 text-lg font-bold text-gold-400">{t("footer_explore")}</div>
            {NAV_LINKS.map((link) => (
              <a key={link.href} href={link.href} className="mb-3 block text-fog-200 last:mb-0">
                {link.label}
              </a>
            ))}
          </div>
          <div>
            <div className="mb-4 text-lg font-bold text-gold-400">{t("footer_contact")}</div>
            <a href={`mailto:${BRAND.contactEmail}`} className="mb-3 block text-fog-200">
              {BRAND.contactEmail}
            </a>
            <Link to="/signup" className="block text-fog-200">
              {t("cta_primary")}
            </Link>
          </div>
        </div>
      </div>
      <div className="container mx-auto max-w-content px-6 text-sm text-white/[0.35] sm:px-16">{t("brand_copyright")}</div>
    </footer>
  )
}
